import React, { useEffect } from 'react';
import { trackPurchase } from '../services/metaPixel';
import './BookingConfirmationModal.css';

const BookingConfirmationModal = ({ isOpen, onClose, bookingData }) => {
  // Track conversión cuando se abre el modal
  useEffect(() => {
    if (isOpen && bookingData) {
      trackPurchase(bookingData);
    }
  }, [isOpen, bookingData]);

  if (!isOpen) return null;

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('es-AR', { 
      day: '2-digit', 
      month: '2-digit', 
      year: 'numeric' 
    });
  };

  const formatDateTime = (dateString, timeString) => {
    const date = formatDate(dateString);
    return timeString ? `${date} - ${timeString}` : date;
  };

  const formatCurrency = (amount) => {
    return `$ ${amount.toLocaleString('es-AR', { minimumFractionDigits: 2 })}`;
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div className="success-icon">✓</div>
          <h2>¡Reserva Registrada!</h2>
        </div>

        <div className="modal-body">
          <div className="booking-summary">
            <h3>Resumen de tu Reserva</h3>
            
            <div className="summary-section">
              <h4>📋 Código de Reserva</h4>
              <p className="booking-code">{bookingData.bookingCode}</p>
              <p className="booking-code-hint">Guarda este código para consultar tu reserva</p>
            </div>

            <div className="summary-section">
              <h4>🚗 Vehículo</h4>
              <p>{bookingData.vehicleName}</p>
            </div>

            <div className="summary-section">
              <h4>📍 Ubicación y Fechas</h4>
              <div className="location-dates">
                <div className="date-item">
                  <span className="label">Retiro:</span>
                  <span>{bookingData.pickupLocation}</span>
                  <span className="date">{formatDateTime(bookingData.pickupDate, bookingData.pickupTime)}</span>
                </div>
                <div className="date-item">
                  <span className="label">Devolución:</span>
                  <span>{bookingData.returnLocation}</span>
                  <span className="date">{formatDateTime(bookingData.returnDate, bookingData.returnTime)}</span>
                </div>
              </div>
            </div>

            {bookingData.insurances && Object.keys(bookingData.insurances).length > 0 && (
              <div className="summary-section">
                <h4>🛡️ Seguros Seleccionados</h4>
                <ul>
                  {Object.entries(bookingData.insurances).map(([key, value]) => 
                    value && <li key={key}>{key === 'intermediate' ? 'Intermedio' : 'Máximo'}</li>
                  )}
                </ul>
              </div>
            )}

            {bookingData.additionals && Object.keys(bookingData.additionals).length > 0 && (
              <div className="summary-section">
                <h4>➕ Adicionales</h4>
                <ul>
                  {Object.entries(bookingData.additionals).map(([key, qty]) => 
                    qty > 0 && <li key={key}>{key}: {qty}</li>
                  )}
                </ul>
              </div>
            )}

            <div className="summary-section">
              <h4>👤 Datos del Cliente</h4>
              <p>{bookingData.customerName}</p>
              <p>{bookingData.customerEmail}</p>
              <p>{bookingData.customerPhone}</p>
            </div>

            <div className="summary-section total-section">
              <h4>💰 Total</h4>
              <p className="total-amount">{formatCurrency(bookingData.totalPrice)}</p>
              <p className="payment-method">Método: {bookingData.paymentMethod}</p>
            </div>
          </div>

          <div className="next-steps">
            <h3>📧 Próximos Pasos</h3>
            <ol>
              <li>Recibirás un email de confirmación en <strong>{bookingData.customerEmail}</strong></li>
              <li>Nuestro equipo revisará tu solicitud</li>
              <li>Te contactaremos en las próximas 24-48 horas</li>
              <li>Guarda tu código de reserva: <strong>{bookingData.bookingCode}</strong></li>
            </ol>
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn-primary" onClick={onClose}>
            Entendido
          </button>
        </div>
      </div>
    </div>
  );
};

export default BookingConfirmationModal;
